import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vidle from 'v-idle'
import 'vuetify/dist/vuetify.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faChalkboardTeacher, faEye, faEyeSlash, faIdCard, faFlagCheckered, faUniversity, faCreditCard, faMoneyBillWaveAlt, faSpinnerThird
        } from '@fortawesome/pro-solid-svg-icons'
import { faCalendarAlt, faComment, faEnvelope, faPhoneAlt, faTimes
        } from '@fortawesome/pro-regular-svg-icons'
import { faCcVisa, faCcAmex, faCcDiscover, faCcMastercard
        } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMask from 'v-mask'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueCardFormat from 'vue-credit-card-validation';
Vue.use(VueCardFormat);

//watches for and handles idle user states
Vue.use(Vidle)

// For more options see below
Vue.use(VueReCaptcha, { siteKey: `${process.env.VUE_APP_RECAPTCHA_KEY}` })

Vue.use(VueMask, {
  placeholders: {
    M: /\d{1,2}/
  }
});

library.add(faUser, faChalkboardTeacher, faEye, faEyeSlash, faIdCard, faFlagCheckered, faUniversity,
            faCreditCard, faMoneyBillWaveAlt, faCalendarAlt, faSpinnerThird, faCcVisa, 
            faCcAmex, faCcDiscover, faCcMastercard, faComment, faEnvelope, faPhoneAlt, faTimes);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.prototype.$appName = process.env.VUE_APP_TITLE
Vue.prototype.$baseURL = process.env.VUE_APP_BASE_URL




new Vue({
  router,
  store,
  vuetify, 
  render: h => h(App)
}).$mount('#app')
